import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

class PrivateRouteComponent extends Component {
  render() {
    const { component: Component, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={props => this.props.authenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            from={this.props.location.pathname}
            to="/reports/login"
          />
        )}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  authenticated: state.session.authenticated
});

export const PrivateRoute =  connect(mapStateToProps)(PrivateRouteComponent);

class PublicRouteComponent extends Component {
  render() {
    const { component: Component, ...rest } = this.props;
    console.log(this.props)
    return (
      <Route
        {...rest}
        render={props =>
          <Component {...props} />
        }
      />
    )
  }
}

export const PublicRoute = connect(mapStateToProps)(PublicRouteComponent);


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js